const inviteSignup = {
  toastr: 'Invitación enviada',
  toastr1: 'La invitación fue enviada con éxito'
};

export default inviteSignup;
